<div class="shadow-sm rounded-lg flex flex-col h-full">
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-medium">IA States</div>
  <div class="p-4 flex-grow overflow-auto">
    <kendo-grid
      [kendoGridBinding]="repState.repIaStates"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
      (remove)="removeHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button gdAdminOnly
          type="button"
          kendoGridAddCommand
          kendoButton
          themeColor="primary"
          icon="plus"
          class="mr-2"
        >
          Add New Record
        </button>
        <button gdAdminOnly
          type="button"
          kendoButton
          icon="refresh"
          class="ml-auto"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column field="stateText" title="State" width="300">
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeStateList"
            textField="stateText"
            valueField="stateValue"
            valuePrimitive="true"
            [formControl]="formGroup.get('state')"
            required
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="iafees"
        title="Fee"
        width="50"
        [format]="{ style: 'currency', currency: 'USD' }"
        [editable]="false"
      ></kendo-grid-column>
      <kendo-grid-command-column title="Command" width="220" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoGridEditCommand [primary]="true" kendoButton themeColor="primary" icon="edit" class="mr-1" gdAdminOnly>Edit</button>
          <button kendoGridRemoveCommand *ngIf="dataItem.active" kendoButton themeColor="error" icon="trash" class="mr-1" gdAdminOnly>Remove</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid" kendoButton themeColor="success" icon="save" class="mr-1" gdAdminOnly>Save</button>
          <button kendoGridCancelCommand kendoButton themeColor="light" icon="cancel" class="mr-1" gdAdminOnly>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
